<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/dashboard" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo-dark.png" alt="" height="100%" width="75%">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="100%" width="75%">
          </span>
        </a>

        <a routerLink="/dashboard" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo-light.png" alt="" height="100%" width="75%">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-light.png" alt="" height="100%" width="75%">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
        id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- App Search-->
      <!--  <form class="app-search d-none d-lg-block">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="{{'HEADER.SEARCH' | translate}}">
          <span class="uil-search"></span>
        </div>
      </form> -->

    </div>

    <div class="d-flex">

      <!--  <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
        <button type="button" class="btn header-item noti-icon waves-effect" id="page-header-search-dropdown"
          data-toggle="dropdown" aria-haspopup="true" ngbDropdownToggle aria-expanded="false">
          <i class="mdi mdi-magnify"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-search-dropdown">

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div> -->

      <!--language -->

      <!-- <div class="dropdown d-inline-block language-switch" ngbDropdown>
        <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown" ngbDropdownToggle>
          <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" alt="Header Language" height="16"><span
            class="ms-1">{{countryName}}</span>
          <img *ngIf="flagvalue === undefined" src="{{valueset}}" alt="Header Language" height="16">
          <span *ngIf="flagvalue === undefined" class="ms-1">English</span>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          
          <a href="javascript:void(0);" class="dropdown-item notify-item" *ngFor="let item of listLang"
            (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
            <img src="{{item.flag}}" alt="user-image" class="me-1" height="12">
            <span class="align-middle">{{item.text}}</span>
          </a>
         
        </div>
      </div> -->

      <!--End language -->

      <!--     <div class="dropdown d-none d-lg-inline-block ms-1" ngbDropdown>
        <button type="button" class="btn header-item noti-icon waves-effect" ngbDropdownToggle>
          <i class="uil-apps"></i>
        </button>
   
      </div> -->

      <!--Full screen -->
      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon waves-effect" data-toggle="fullscreen"
          (click)="fullscreen()">
          <i class="uil-minus-path"></i>
        </button>
      </div>
      <!--End Full screen -->

      <!--Notifications-->

      <div class="dropdown d-inline-block" ngbDropdown (openChange)="onNotificationsOpen($event)">
        <button type="button" class="btn header-item noti-icon waves-effect" id="page-header-notifications-dropdown"
          ngbDropdownToggle>
          <i class="uil-bell"></i>
          <span *ngIf="unreadCount > 0" class="badge bg-danger rounded-pill">{{ unreadCount }}</span>
        </button>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0 font-size-16">Notifications</h6>
              </div>
             
            </div>
          </div>
          <ngx-simplebar style="position: relative; height: 230px;">
            <div *ngIf="notifications.length === 0" class="p-3 text-muted text-center">
              Aucune notification
            </div>
            <a *ngFor="let notif of visibleNotifications" [href]="notif.link || 'javascript:void(0);'"
              class="text-reset notification-item" [ngClass]="{ 'notification-unread': !notif.read }">
              <div class="d-flex align-items-start">
                <div class="flex-shrink-0 me-3">
                  <img *ngIf="notif.avatar" [src]="notif.avatar" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                  <div *ngIf="!notif.avatar" class="avatar-xs">
                    <span class="avatar-title rounded-circle font-size-16" [ngClass]="notif.read ? 'bg-light text-dark' : 'bg-primary'">
                      <i [class]="notif.icon || 'uil-bell'"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1">{{ notif.title }}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ notif.message }}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i> {{ getNotificationTime(notif) }}</p>
                  </div>
                </div>
              </div>
            </a>
          </ngx-simplebar>

          <div *ngIf="notifications.length > notificationDisplayLimit" class="p-2 border-top d-grid">
            <button type="button" class="btn btn-sm btn-link font-size-14 text-center" (click)="loadMoreNotifications()">
              <i class="uil-arrow-circle-right me-1"></i> Charger plus
            </button>
          </div>
        </div>
      </div>

      <!--End Notifications-->

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item waves-effect" ngbDropdownToggle id="page-header-user-dropdown">
          <img [src]="'data:image/png;base64,'+ image" style="border-radius:50%;margin-right:1rem" width="50px"
            height="50px" alt="Image" />
          <!--  <a href="/account/login" class=" d-flex ">Déconnecter</a> -->
          <span class="d-none d-xl-inline-block ms-1 fw-medium font-size-15">{{name}}</span>
          <i class="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>

          <!-- start edit pwd-->
          <a class="dropdown-item d-block" [routerLink]="['/history/validation']">
            <span style="color: black;" class="mt-4 text-center"> Modifier mot de passe</span>
            <span class="badge badge-soft-success badge-pill mt-1 ms-2">03</span>
          </a>
          <!-- end edit pwd-->

          <!-- start edit img-->
          <a class="dropdown-item d-block" href="javascript:void(0);">
            <button type="button" class="btn btn-light dropdown-toggle" id="dropdownMenuButton"
              (click)='updatePicture()' style=" background: none; border: none; ">
              <span style="color: black;">Modifier votre photo de profil</span>
            </button>
          </a>
        </div>
      </div>
      <div class="dropdown d-inline-block" style="margin-top: 20px;">
        <a [routerLink]="['/account/login']" class=" d-block auth-logo" (click)="logout()" title="Déconnecter">
          <mat-icon style="color: orangered;margin-left: 10px;">exit_to_app</mat-icon>
        </a>
      </div>
    </div>
  </div>
</header>